module.exports = __webpack_public_path__ + "files/fa0619542e99eb45187589cbdd55cd95.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activities-2.png
// module id = 518
// module chunks = 76